import { createSelector } from 'reselect';

export const selectCustomerDetails = createSelector(
  (state) => state.customerDetails,
  (customerDetails) => customerDetails.payload
);

export default selectCustomerDetails;
